import { createFileRoute } from "@tanstack/react-router";
import { HsePage, hseHead } from "@/pages/HsePage";

export const Route = createFileRoute("/de/hse-management")({
  head: () => hseHead("de"),
  component: () => <HsePage locale="de" />,
});
